import baseComponent from '@/scripts/baseComponent';
import authApi from '@/api/common/auth';
import { API_CALL_STATUS } from "@/constant/config";
import { RESTRICTED_EMAIL_DOMAIN_MODIFY_TYPE } from "@/constant/systemManagerStatus";
import { mapState } from "vuex";

export default {

    extends: baseComponent,

    data() {
        return {
            domain: null,
            description: null
        };
    },

    props: {
        element: {
            type: Array,
            default: []
        },
    },

    computed: {
        ...mapState({
            user: state => state.auth.user,
            listServicePack: state => state.common.listServicePack,
        }),
    },

    created() {

    },

    mounted() {
        if (this.element.length === 1) {
            this.domain = this.element[0].domain;
            this.description = this.element[0].description;
        } else {
            this.domain = null;
            this.description = null;
        }
    },

    methods: {

        // Domain change event
        domainChangeEvent() {
            if (this.domain) {
                this.domain = this.domain.substring(this.domain.lastIndexOf("@") + 1);
            }
        },

        // Close this pop-up
        closePopup() {
            this.$emit("processingEvent", { event: "closePopup", data: "restricted-email-domain-modify" });
        },


        // Modify domain
        modifyDomain() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            let request = {
                listData: this.element,
                type: RESTRICTED_EMAIL_DOMAIN_MODIFY_TYPE.INFORMATION,
                domain: this.domain,
                description: this.description,
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            authApi.restrictedEmailDomainModify(request)
                .then((res) => {
                    try {
                        this.closePopup();
                        this.$emit("processingEvent", { event: "performAction", data: { action: "refresh" } });
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.feedStatusLoading(API_CALL_STATUS.FAILED);
                    }
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            if (this.$route.path !== '/login') {
                                setTimeout(() => {
                                    location.href = "/login";
                                }, 2000);
                            }
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.log("getData -> error", error)
                                    this.$store.dispatch("common/showUnkownError", error, "Error");
                                    break;
                            }
                        }
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.$store.dispatch("common/showUnkownError", error, "Error");
                    }
                    this.feedStatusLoading(API_CALL_STATUS.FAILED);
                });
        },
    },
}